<template>
  <div>
    <Layout/>
    <h4>Elementos por empresa</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idElemEmpr" class="form-label">IdElemEmpr</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idElemEmpr" name="idElemEmpr" v-model="datoElemEmpr.idElemEmpr" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoElemEmpr.idEmpresa" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoElemEmpr.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoElemEmpr.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaVig" class="form-label">FechaVig</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaVig" name="fechaVig" v-model="datoElemEmpr.fechaVig" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="valor" class="form-label">Valor</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="valor" name="valor" v-model="datoElemEmpr.valor" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarElemEmpr" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditElemEmpr" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdAtencionDet</th>
          <th scope="col">IdAtencion</th>
          <th scope="col">IdElemEmpr</th>
          <th scope="col">Cantidad</th>
          <th scope="col">PrecioUnitario</th>
          <th scope="col">Estado</th>
          <th scope="col">ElemEmprFechaReg</th>
          <th scope="col">AtencionFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="atenciondet in datosPaginados" :key="atenciondet.idAtencionDet">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(atenciondet.idAtencionDet)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(atenciondet.idAtencionDet)" title="Editar">edit_square</i></td>
          <td>{{atenciondet.idAtencionDet}}</td>
          <td>{{atenciondet.idAtencion}}</td>
          <td>{{atenciondet.idElemEmpr}}</td>
          <td>{{atenciondet.cantidad}}</td>
          <td>{{atenciondet.precioUnitario}}</td>
          <td>{{atenciondet.estado}}</td>
          <td>{{getFormattedDate(atenciondet.elemEmprFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(atenciondet.atencionFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteElemEmpr(atenciondet.idAtencionDet)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencionDet" class="form-label">IdAtencionDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencionDet" name="idAtencionDet" v-model="datoAtencionDet.idAtencionDet" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtencionDet.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idElemEmpr" class="form-label">IdElemEmpr</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idElemEmpr" name="idElemEmpr" v-model="datoAtencionDet.idElemEmpr" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cantidad" class="form-label">Cantidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="cantidad" name="cantidad" v-model="datoAtencionDet.cantidad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="precioUnitario" class="form-label">PrecioUnitario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="precioUnitario" name="precioUnitario" v-model="datoAtencionDet.precioUnitario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAtencionDet" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAtencionDet" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      elememprs : [],
      datoElemEmpr : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idElemEmpr: '',
      elementos : [],
// Variables master
// Variables details
      atenciondets : [],
      datoAtencionDet : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      atencions : [],
      elemEmprs : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idElemEmpr = this.$route.params.p_idelemempr
    this.abrirEditar(this.p_idElemEmpr)
    this.getDataPagina(this.paginaActual)
    this.fetchElementos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idElemento'
        ,'fechaVig'
        ,'valor'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idElemento'
        ,'fechaVig'
        ,'valor'
      ];
      return validarForm(this.datoElemEmpr, requiredFields, requiredFieldsText);
    },
    async guardarElemEmpr(){
      if(this.validarForm() === 1){
        try {
          this.datoElemEmpr.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/elememprs', this.datoElemEmpr)
          swal("Correcto!", "ElemEmpr creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditElemEmpr(){
      if(this.validarForm() === 1){
        try {
          await api.post('/elememprs', this.datoElemEmpr)
          swal("Correcto!", "ElemEmpr creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoElemEmpr={}
      this.titulo   = 'Crear Elementos por empresa'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idElemEmpr){
      this.modalWindow = true
      if(idElemEmpr != null){    
           api.get('/vwelememprs/'+idElemEmpr).then(resp=>{
          this.datoElemEmpr = resp.data;
           });
      }
      this.titulo   = 'Editar Elementos por empresa'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarElemEmpr(){
      this.$router.push('/ElemEmpr')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.atenciondets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwatenciondets/nombre/'+this.nombreBusqueda).then(response=>{
          this.atenciondets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.atenciondets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwatenciondets').then(response=>{
      this.atenciondets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.atenciondets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idElemento'
        ,'fechaVig'
        ,'valor'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idElemento'
        ,'fechaVig'
        ,'valor'
      ];
      return validarForm(this.datoElemEmpr, requiredFields, requiredFieldsText);
    },
    async guardarAtencionDet(){
      if(this.validarForm() === 1){
        try {
          this.datoAtencionDet.idElemEmpr = this.datoElemEmpr.idElemEmpr;
          await api.post('/atenciondets', this.datoAtencionDet)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AtencionDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAtencionDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atenciondets', this.datoAtencionDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AtencionDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAtencionDet={}
      this.titulo   = 'Crear Elementos por empresa'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAtencionDet){
      this.modalWindow = true
      if(idAtencionDet != null){    
           api.get('/vwatenciondets/'+idAtencionDet).then(resp=>{
          this.datoAtencionDet = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Elementos por empresa'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAtencionDet){
      this.modalWindow = true
      if(idAtencionDet != null){
        this.$router.push('/atenciondetmd/'+idAtencionDet)
      }
    },
    async deleteAtencionDet (idAtencionDet) {
      try{
        await api.delete('/atenciondets/'+idAtencionDet)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
    fetchElemEmprs() {
      fetch('http://localhost:8080/api/v1/elememprs')
        .then(response => response.json())
        .then(data => {
          this.elemEmprs = data;
        })
        .catch(error => {
          console.error('Error fetching elemEmprs:', error);
        });
    },
  },
}
</script>
